angular.module('qkr').factory('cases21Service', ($http, utils, appConfig) => ({

        /** Get all the CASES21 Families */
        loadFamilyInfo() {
            return $http.get(appConfig.apiUrl + 'beneficiary/listFamilies', {withCredentials: true})
                .then(response => response.data);
        },

        hideFamilyNumber(family) {
            const updateCmd = {
                beneficiaryIds: family.beneficiaryIds,
                familyNumber: family.familyNumber
            };
            return $http.post(appConfig.apiUrl + 'beneficiary/hideFamily', updateCmd);
        },

        unHideFamilyNumber(family) {
            const updateCmd = {
                beneficiaryIds: family.beneficiaryIds,
                familyNumber: family.familyNumber
            };
            return $http.post(appConfig.apiUrl + 'beneficiary/unHideFamily', updateCmd);
        },

        /** Update family number for a family (identified by beneficiaryIds) */
        updateFamilyNumber(family) {
            const updateCmd = {
                beneficiaryIds: family.beneficiaryIds,
                familyNumber: family.familyNumber
            };
            return $http.post(appConfig.apiUrl + 'beneficiary/updateFamily', updateCmd);
        },

        uploadFile(selectedFile) {
            const fd = new FormData();
            fd.append('cases21File', selectedFile);
            return $http.post(appConfig.apiUrl + 'cases21Upload/uploadCases21File', fd, {
                transformRequest: angular.identity,
                headers: {'Content-Type': undefined}
            });
        },

        getUnknownFamilyNumberConfig() {
            return $http.get(appConfig.apiUrl + 'beneficiary/getUnknownFamilyNumberConfig', {withCredentials: true})
                .then((response) => response.data);
        },

        saveUnknownFamilyNumberEmailConfig(data) {
            return $http.post(appConfig.apiUrl + 'beneficiary/updateUnknownFamilyNumberConfig', data);
        },

        deleteFamily(family) {
            return $http.post(appConfig.apiUrl + 'beneficiary/deleteFamily', family);
        },

        addFilterKey(family) {
            return Object.assign({}, family,
                {filterKey: family.lastName + family.childList + family.familyNumber});
        },

        invalidFamilyNumber(family) {
            if (family.familyNumber) {
                const validInput = /^[0-9a-zA-Z]+$/;

                if (!family.familyNumber.match(validInput)) {
                    return true; // Invalid, not a number
                }

                if (!utils.hasNoValue(family.serverFamilyNumber)) {
                    if (family.serverFamilyNumber === family.familyNumber) {
                        return true; // No need to update is the same
                    }
                }

                return false; // Valid - > 7 digit number
            } else {
                return false; // Blank is allowed
            }
        }

}));



// WEBPACK FOOTER //
// ./src/services/cases21.services.js